import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/img/empty.png'


const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "page-inner page-left" }
const _hoisted_3 = { class: "page-box-title title1" }
const _hoisted_4 = { class: "paper-tabs" }
const _hoisted_5 = { class: "history-box" }
const _hoisted_6 = {
  key: 0,
  class: "page-inner-box empty"
}
const _hoisted_7 = { class: "history-box-item-top" }
const _hoisted_8 = { class: "title1" }
const _hoisted_9 = { class: "history-box-item-tag" }
const _hoisted_10 = { class: "history-box-item-inner" }
const _hoisted_11 = { class: "history-box-item-bottom" }
const _hoisted_12 = { class: "history-box-item-time" }
const _hoisted_13 = { style: {"text-align":"center","margin-top":"10px"} }
const _hoisted_14 = { class: "page-inner page-right" }
const _hoisted_15 = { class: "teaching-box" }
const _hoisted_16 = { class: "teaching-box-btn" }
const _hoisted_17 = { style: {"float":"right"} }
const _hoisted_18 = {
  class: "page-inner-box",
  style: {"max-height":"300px","height":"auto"}
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { style: {"width":"100%"} }
const _hoisted_22 = { class: "history-file" }
const _hoisted_23 = {
  key: 0,
  class: "page-inner-box"
}
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  key: 1,
  class: "page-inner-box"
}
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = {
  key: 0,
  class: "page-inner-box"
}
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = {
  key: 1,
  class: "page-inner-box"
}
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = {
  key: 0,
  class: "page-inner-box"
}
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = {
  key: 1,
  class: "page-inner-box"
}
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = {
  key: 4,
  class: "page-inner-box empty"
}

import { ref, reactive, onMounted, computed, nextTick } from 'vue';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { getHistory, getCorrecting, getRewrite, getPolishing, delArti,html2Pdf } from "@/api/composition.js"
import { useRouter } from 'vue-router';
import { ElMessage } from "element-plus";

export default /*@__PURE__*/_defineComponent({
  __name: 'workHistory',
  setup(__props) {

const router = useRouter()
const tabActive = ref('0')
const teachingActive = ref('artiCorrecting')
const tableList = ref([])
const artiCorrectingInfo = ref({})
const artiCorrectingResultInfo = ref({})
const artiRewriteInfo = ref({})
const artiRewriteResultInfo = ref({})
const artiPolishingInfo = ref({})
const artiPolishingResultInfo = ref({})
const artiCorrectingId = ref('')
const artiRewriteId = ref('')
const artiPolishingId = ref('')
const aiMessage = ref()
const handleType = ref('correctResult')
const searchInfo = ref({})
const romanNumerals = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ"];
const regex = new RegExp(`(${romanNumerals.join('|')})|([^${romanNumerals.join('')}]+)`, 'g');
const romanNumeralsArr = romanNumerals
const compositionType = [{
    label: '全部',
    value: '0'
},
{
    label: '未重写',
    value: '1'
},
{
    label: '已重写',
    value: '2'
},
{
    label: '已润色',
    value: '3'
}
]

const correctingType = [{
    label: '全部',
    value: '00'
},
{
    label: '常规评阅',
    value: '01'
}, {
    label: '教学评阅',
    value: '02'
},
{
    label: '考试评阅',
    value: '03'
}
]
const fileList = computed(() => {
    if (teachingActive.value == 'artiCorrecting') {
        return artiCorrectingId.value && artiCorrectingInfo.value.artiCorrectingFileUrlList || []
    } else if (teachingActive.value == 'artiRewrite') {
        return artiRewriteId.value && artiRewriteInfo.value.artiRewriteFileUrlList || []
    } else if (teachingActive.value == 'artiPolishing') {
        return artiPolishingId.value && artiPolishingInfo.value.artiPulishingFileUrlList || []
    }
    return []
})
const picFinish=computed(() => {
    let isFinish = ''
    if (tabActive.value == 'artiCorrecting') {
        isFinish = artiCorrectingId.value && artiCorrectingInfo.value.isFinish?artiCorrectingInfo.value.isFinish:''
    } else if (tabActive.value == 'artiRewrite') {
        isFinish = artiRewriteId.value && artiRewriteInfo.value.isFinish?artiRewriteInfo.value.isFinish:''
    } else if (tabActive.value == 'artiPolishing') {
        isFinish = artiPolishingId.value && artiPolishingInfo.value.isFinish?artiPolishingInfo.value.isFinish:''
    }
    return isFinish
})
const artiText = computed(() => {
    let value = ''
    if (teachingActive.value == 'artiCorrecting') {
        value=artiCorrectingId.value && artiCorrectingInfo.value.artiCorrectingTxt?artiCorrectingInfo.value.artiCorrectingTxt: ''
    } else if (teachingActive.value == 'artiRewrite') {
        value=artiRewriteId.value && artiRewriteInfo.value.artiRewriteTxt?artiRewriteInfo.value.artiRewriteTxt:''
    } else if (teachingActive.value == 'artiPolishing') {
        value=artiPolishingId.value && artiPolishingInfo.value.artiPolishingTxt?artiPolishingInfo.value.artiPolishingTxt:''
    }
    let arr = value.split('\n')
    let info = ''
    arr.forEach((item,index)=>{
        if(index==0){
            info+=`<div style="text-align:center;text-indent:0;">${item}</div>`
        }else{
            info+=`<div style="text-indent:2em;">${item}</div>`
        }
        
    })
    return info
})
const pageInfo = ref({
    current: 1,
    size: 10,
    total: 10
})
const pageShow = ref(true)
const isDelFlag = ref(false)
function resetEvent() {
    searchInfo.value = {}
}
function correctingTypeFormat(val) {
    switch (val) {
        case '01':
            return '常规评阅'
        case '02':
            return '教学评阅'
        case '03':
            return '考试评阅'
        default:
            return val
    }
}
function manageEvent() {
    isDelFlag.value = true
}
function tabClick(item) {
    if (tabActive.value == item.value) return
    tabActive.value = item.value;
    handleCurrentChange(1)
}
function handleSizeChange(val) {
    pageInfo.value.size = val;
    getList()
}
function handleCurrentChange(val) {
    pageInfo.value.current = val;
    pageShow.value = false;
    getList()
    nextTick(() => {
        pageShow.value = true;
    })
}
function getList(cb) {
    const params = {
        current: pageInfo.value.current,
        size: pageInfo.value.size,
        type: searchInfo.value.type || '0',
        tabType: searchInfo.value.tabType || '00',
    }
    if (searchInfo.value.date) {
        params.startDate = searchInfo.value.date[0]
        params.endDate = searchInfo.value.date[1]
    }
    pageInfo.value.total = 0;
    tableList.value = []
    getHistory(params).then((res: any) => {
        tableList.value = (res.data.records || []).map(item => {
            return {
                ...item,
                checked: false
            }
        })
        pageInfo.value.total = res.data.total || 0;
        cb && cb()
    })
}
function statusFormat(val) {
    const obj = compositionType.find(item => {
        return item.value == val
    })
    return obj.label
}
function toCorrectResult(item, type) {
    handleType.value = type
    if (type == 'runseResult') {
        artiPolishingId.value = item.artiPolishingId
        item.artiPolishingId && getPolishingInfo((res) => {
            teachingActive.value = 'artiPolishing'
            aiMessage.value = res.data.artiPulishingResult;
        })
    } else {
        artiCorrectingId.value = item.artiCorrectingId
        artiRewriteId.value = item.artiRewriteId
        artiPolishingId.value = item.artiPolishingId
        item.artiCorrectingId && getCorrectingInfo((res) => {
            teachingActive.value = 'artiCorrecting'
            aiMessage.value = res.data.artiCorrectingResult;
        })
        item.artiRewriteId && getRewriteInfo()
        item.artiPolishingId && getPolishingInfo()
    }


}
function getCorrectingInfo(cb) {
    getCorrecting(artiCorrectingId.value).then((res: any) => {
        artiCorrectingInfo.value = res.data;
        artiCorrectingResultInfo.value = res.data.artiCorrectingResult ? resultFormat(res.data
            .artiCorrectingResult) : {}
        cb && cb(res)
    })
}
function getRewriteInfo() {
    getRewrite(artiRewriteId.value).then((res: any) => {
        artiRewriteInfo.value = res.data;
        artiRewriteResultInfo.value = res.data.artiRewriteResult ? resultFormat(res.data
            .artiRewriteResult) : {}
    })
}
function getPolishingInfo(cb) {
    getPolishing(artiPolishingId.value).then((res: any) => {
        artiPolishingInfo.value = res.data;
        artiPolishingResultInfo.value = res.data.artiPulishingResult ? resultFormat(res.data
            .artiPulishingResult) : {}
        cb && cb(res)
    })
}
function resultFormat(content) {
    const matches = content.match(regex) || [];
    let resultArr = matches.filter(match => match !== '');
    let resultNum = {},
        result = {},
        currentKey = '';
    resultArr.forEach(info => {
        if (romanNumeralsArr.includes(info)) {
            if (info in resultNum) {
                resultNum[info] = resultNum[info] + 1;
                result[info].push('');
            } else {
                resultNum[info] = 1;
                result[info] = [''];
            }
            currentKey = info;
        } else if (currentKey in result) {
            if (resultNum[currentKey] == 1) {
                result[currentKey][resultNum[currentKey] - 1] += info.replace(/^\s+/,
                    "").replace(/\n+/g, '<br/>');

            } else {
                result[currentKey][resultNum[currentKey] - 1] += info.replace(/\n+/g, '<br/>');
            }

        }
    })
    return result
}
function teachingClick(val) {
    switch (val) {
        case 'artiCorrecting':
            aiMessage.value = artiCorrectingInfo.value.artiCorrectingResult;
            break;
        case 'artiRewrite':
            aiMessage.value = artiRewriteInfo.value.artiRewriteResult;
            break;
        case 'artiPolishing':
            aiMessage.value = artiPolishingInfo.value.artiPulishingResult;
            break;
        default:
            return val
    }
}

function toPolish(item) {
    router.push({
        path: '/composition/polish',
        query: {
            artiRewriteId: item.artiRewriteId,
            artiCorrectingId: item.artiCorrectingId,
            page: 'history'
        }
    })
}
function toRewrite(item) {
    router.push({
        path: '/composition/rewrite',
        query: {
            artiCorrectingId: item.artiCorrectingId,
            page: 'history'
        }
    })
}
function delEvent() {
    console.log(tableList.value)
    let arr = tableList.value.filter(item => {
        return item.checked
    })
    if (!arr.length) {
        return ElMessage.warning('请选择记录！');
    } else {
        delArti(arr.map(item => {
            return item.artiCorrectingId
        })).then(res => {
            ElMessage.success('删除成功！');
            handleCurrentChange(1)
        })
    }
}

function cancelEvent() {
    isDelFlag.value = false;
    tableList.value.map(item => {
        item.checked = false
    })
}

function exportEvent() {
    let resultInfo={}
    if (teachingActive.value == 'artiCorrecting') {
        resultInfo=artiCorrectingResultInfo.value
    } else if (teachingActive.value == 'artiRewrite') {
        resultInfo=artiRewriteResultInfo.value
    } else if (teachingActive.value == 'artiPolishing') {
        resultInfo=artiPolishingResultInfo.value
    }
    const keys = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ"];
    let text = ''
    keys.forEach(key => {
        if (key in resultInfo && resultInfo[key].length) {
            resultInfo[key].forEach((item, index) => {
                text += `<div>${item}</div>`
                if (key == 'Ⅵ') {
                    if (resultInfo.Ⅶ && resultInfo.Ⅶ.length >= resultInfo.Ⅵ.length) {
                        text += `<div>${resultInfo.Ⅶ[index]}</div>`
                    }
                    if (resultInfo.Ⅷ && resultInfo.Ⅷ.length >= resultInfo.Ⅵ.length) {
                        text += `<div>${resultInfo.Ⅷ[index]}</div>`
                    }
                }
            })
        }
    })

    html2Pdf({
        content: text,
        picUrlList: fileList.value || []
    }).then(res => {
        console.log(res)
        let temp = document.createElement('a') // 创建a标签
        temp.download = '评阅结果.pdf'// 设置下载名称
        temp.href = res.data;

        // 手动触发点击事件
        temp.click()
    })
}

onMounted(() => {
    getList(() => {
        toCorrectResult(tableList.value[0], 'correctResult')
    })
})

return (_ctx: any,_cache: any) => {
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("span", null, "作文秒评记录", -1)),
        (!isDelFlag.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              style: {"float":"right"},
              link: "",
              onClick: manageEvent
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Setting)
                  ]),
                  _: 1
                }),
                _cache[7] || (_cache[7] = _createTextVNode("管理"))
              ]),
              _: 1,
              __: [7]
            }))
          : _createCommentVNode("", true),
        (isDelFlag.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_el_button, {
                style: {"float":"right"},
                link: "",
                onClick: delEvent
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Delete)
                    ]),
                    _: 1
                  }),
                  _cache[8] || (_cache[8] = _createTextVNode("删除"))
                ]),
                _: 1,
                __: [8]
              }),
              _createVNode(_component_el_button, {
                style: {"float":"right"},
                link: "",
                onClick: cancelEvent
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode(" 取消")
                ])),
                _: 1,
                __: [9]
              })
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_form, { model: searchInfo.value }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "作文状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: searchInfo.value.type,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInfo.value.type) = $event)),
                          style: {"width":"100%"},
                          placeholder: "请选择作文状态"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(compositionType, (item) => {
                              return _createVNode(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "评阅类型" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: searchInfo.value.tabType,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchInfo.value.tabType) = $event)),
                          style: {"width":"100%"},
                          placeholder: "请选择评阅类型"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(correctingType, (item) => {
                              return _createVNode(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "时间范围" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_config_provider, { locale: _unref(zhCn) }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              "value-format": "YYYY-MM-DD",
                              modelValue: searchInfo.value.date,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchInfo.value.date) = $event)),
                              type: "daterange",
                              "range-separator": "至",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["locale"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        color: "#ef8b25",
                        plain: "",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleCurrentChange(1)))
                      }, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode("查询")
                        ])),
                        _: 1,
                        __: [11]
                      }),
                      _createVNode(_component_el_button, {
                        type: "info",
                        plain: "",
                        onClick: resetEvent
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode("重置")
                        ])),
                        _: 1,
                        __: [12]
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!tableList.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[13] || (_cache[13] = [
              _createElementVNode("img", { src: _imports_0 }, null, -1),
              _createElementVNode("div", null, "暂无数据", -1)
            ])))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(tableList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "history-box-item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (isDelFlag.value)
                      ? (_openBlock(), _createBlock(_component_el_checkbox, {
                          key: 0,
                          modelValue: item.checked,
                          "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                          style: {"margin-right":"5px"}
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(_toDisplayString(item.artiCorrectingTitle), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['tag1','correctClass'+item.correctingType])
                    }, _toDisplayString(correctingTypeFormat(item.correctingType)), 3),
                    _createElementVNode("div", {
                      class: _normalizeClass(['tag2','statusClass'+item.type])
                    }, _toDisplayString(statusFormat(item.type)), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.artiCorrectingTxt), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(item.updateTime), 1),
                  _createElementVNode("div", null, [
                    _withDirectives(_createVNode(_component_el_button, {
                      color: "#666",
                      size: "small",
                      plain: "",
                      onClick: ($event: any) => (toRewrite(item))
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode("作文重写")
                      ])),
                      _: 2,
                      __: [14]
                    }, 1032, ["onClick"]), [
                      [_vShow, [1].includes(item.type) || !item.artiRewriteId]
                    ]),
                    _createVNode(_component_el_button, {
                      color: "#666",
                      size: "small",
                      plain: "",
                      onClick: ($event: any) => (toCorrectResult(item,'correctResult'))
                    }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode("批改结果")
                      ])),
                      _: 2,
                      __: [15]
                    }, 1032, ["onClick"]),
                    _withDirectives(_createVNode(_component_el_button, {
                      color: "#ef8b25",
                      size: "small",
                      plain: "",
                      onClick: ($event: any) => (toPolish(item))
                    }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode("作文润色")
                      ])),
                      _: 2,
                      __: [16]
                    }, 1032, ["onClick"]), [
                      [_vShow, [1,2].includes(item.type)]
                    ]),
                    _withDirectives(_createVNode(_component_el_button, {
                      color: "#ef8b25",
                      size: "small",
                      plain: "",
                      onClick: ($event: any) => (toCorrectResult(item,'runseResult'))
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode("润色结果")
                      ])),
                      _: 2,
                      __: [17]
                    }, 1032, ["onClick"]), [
                      [_vShow, [3].includes(item.type)]
                    ])
                  ])
                ])
              ]))
            }), 128))
      ]),
      _createElementVNode("div", _hoisted_13, [
        (pageShow.value)
          ? (_openBlock(), _createBlock(_component_el_config_provider, {
              key: 0,
              locale: _unref(zhCn)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_pagination, {
                  "current-page": pageInfo.value.current,
                  "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((pageInfo.value.current) = $event)),
                  "page-size": pageInfo.value.size,
                  "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((pageInfo.value.size) = $event)),
                  total: pageInfo.value.total,
                  "page-sizes": [10, 20, 30, 50],
                  layout: "total, sizes,jumper",
                  onSizeChange: handleSizeChange,
                  onCurrentChange: handleCurrentChange
                }, null, 8, ["current-page", "page-size", "total"])
              ]),
              _: 1
            }, 8, ["locale"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_el_radio_group, {
            modelValue: teachingActive.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((teachingActive).value = $event)),
            fill: "#fae8d4",
            "text-color": "#ef8b25",
            onChange: teachingClick
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_el_radio_button, {
                label: "第一版",
                value: "artiCorrecting",
                disabled: !artiCorrectingId.value
              }, null, 8, ["disabled"]), [
                [_vShow, ['correctResult'].includes(handleType.value)]
              ]),
              _withDirectives(_createVNode(_component_el_radio_button, {
                label: "重写版",
                value: "artiRewrite",
                disabled: !artiRewriteId.value
              }, null, 8, ["disabled"]), [
                [_vShow, ['correctResult'].includes(handleType.value)]
              ]),
              _withDirectives(_createVNode(_component_el_radio_button, {
                label: "AI润色版",
                value: "artiPolishing",
                disabled: !artiPolishingId.value
              }, null, 8, ["disabled"]), [
                [_vShow, ['correctResult','runseResult'].includes(handleType.value)]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_el_button, {
              color: "#ef8b25",
              size: "small",
              plain: "",
              onClick: exportEvent
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [
                _createTextVNode("导出结果")
              ])),
              _: 1,
              __: [18]
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "correctTitle" }, "作文内容：", -1)),
        (artiText.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              innerHTML: artiText.value
            }, null, 8, _hoisted_19))
          : (_openBlock(), _createElementBlock("div", _hoisted_20, "未输入作文内容"))
      ]),
      (fileList.value.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_alert, {
                title: picFinish.value==0?'图片批改中':'图片批改完成',
                type: picFinish.value==0?'warning':'success',
                closable: false
              }, null, 8, ["title", "type"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "history-file-item",
                  key: index
                }, [
                  _createVNode(_component_el_image, {
                    style: {"width":"100%","height":"100%"},
                    src: item,
                    "zoom-rate": 1.2,
                    "max-scale": 7,
                    "min-scale": 0.2,
                    "preview-src-list": fileList.value,
                    "show-progress": "",
                    "initial-index": index,
                    fit: "cover"
                  }, null, 8, ["src", "preview-src-list", "initial-index"])
                ]))
              }), 128))
            ]),
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "history-tip" }, [
              _createElementVNode("span", { class: "activeColor" }, "*提示："),
              _createElementVNode("span", null, "可点击上方小图放大图片查看作文上传记录")
            ], -1))
          ], 64))
        : _createCommentVNode("", true),
      (teachingActive.value=='artiCorrecting')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (Object.keys(artiCorrectingResultInfo.value).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  (artiCorrectingResultInfo.value.Ⅰ && artiCorrectingResultInfo.value.Ⅰ.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(artiCorrectingResultInfo.value.Ⅰ, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'cⅠ'+index
                        }, [
                          _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_24)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (artiCorrectingResultInfo.value.Ⅱ && artiCorrectingResultInfo.value.Ⅱ.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(artiCorrectingResultInfo.value.Ⅱ, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'cⅡ'+index
                        }, [
                          _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_25)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (artiCorrectingResultInfo.value.Ⅲ && artiCorrectingResultInfo.value.Ⅲ.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(artiCorrectingResultInfo.value.Ⅲ, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "",
                          key: 'cⅢ'+index
                        }, [
                          _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_26)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (artiCorrectingResultInfo.value.Ⅳ && artiCorrectingResultInfo.value.Ⅳ.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(artiCorrectingResultInfo.value.Ⅳ, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "",
                          key: 'cⅣ'+index
                        }, [
                          _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_27)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (artiCorrectingResultInfo.value.Ⅴ && artiCorrectingResultInfo.value.Ⅴ.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(artiCorrectingResultInfo.value.Ⅴ, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "",
                          key: 'Ⅴ'+index
                        }, [
                          _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_28)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (artiCorrectingResultInfo.value.Ⅵ && artiCorrectingResultInfo.value.Ⅵ.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(artiCorrectingResultInfo.value.Ⅵ, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "",
                          key: 'cⅥ'+index
                        }, [
                          _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_29),
                          (artiCorrectingResultInfo.value.Ⅶ && artiCorrectingResultInfo.value.Ⅶ.length>=artiCorrectingResultInfo.value.Ⅵ.length)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                innerHTML: artiCorrectingResultInfo.value.Ⅶ[index]
                              }, null, 8, _hoisted_30))
                            : _createCommentVNode("", true),
                          (artiCorrectingResultInfo.value.Ⅷ && artiCorrectingResultInfo.value.Ⅷ.length>=artiCorrectingResultInfo.value.Ⅵ.length)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                innerHTML: artiCorrectingResultInfo.value.Ⅷ[index]
                              }, null, 8, _hoisted_31))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", {
                    innerHTML: artiCorrectingInfo.value.artiCorrectingResult
                  }, null, 8, _hoisted_33)
                ]))
          ], 64))
        : _createCommentVNode("", true),
      (teachingActive.value=='artiRewrite')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (Object.keys(artiRewriteResultInfo.value).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  (artiRewriteResultInfo.value.Ⅰ && artiRewriteResultInfo.value.Ⅰ.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(artiRewriteResultInfo.value.Ⅰ, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "",
                          key: 'rⅠ'+index
                        }, [
                          _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_35)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (artiRewriteResultInfo.value.Ⅱ && artiRewriteResultInfo.value.Ⅱ.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(artiRewriteResultInfo.value.Ⅱ, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "",
                          key: 'rⅡ'+index
                        }, [
                          _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_36)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (artiRewriteResultInfo.value.Ⅲ && artiRewriteResultInfo.value.Ⅲ.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(artiRewriteResultInfo.value.Ⅲ, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "",
                          key: 'rⅢ'+index
                        }, [
                          _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_37)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (artiRewriteResultInfo.value.Ⅳ && artiRewriteResultInfo.value.Ⅳ.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(artiRewriteResultInfo.value.Ⅳ, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "",
                          key: 'rⅣ'+index
                        }, [
                          _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_38)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (artiRewriteResultInfo.value.Ⅴ && artiRewriteResultInfo.value.Ⅴ.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(artiRewriteResultInfo.value.Ⅴ, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "",
                          key: 'rⅤ'+index
                        }, [
                          _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_39)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (artiRewriteResultInfo.value.Ⅵ && artiRewriteResultInfo.value.Ⅵ.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(artiRewriteResultInfo.value.Ⅵ, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "",
                          key: 'rⅥ'+index
                        }, [
                          _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_40)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("div", {
                    innerHTML: artiRewriteInfo.value.artiRewriteResult
                  }, null, 8, _hoisted_42)
                ]))
          ], 64))
        : _createCommentVNode("", true),
      (teachingActive.value=='artiPolishing')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            (Object.keys(artiPolishingResultInfo.value).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "correctTitle" }, "润色后的作文", -1)),
                  (artiPolishingResultInfo.value.Ⅰ && artiPolishingResultInfo.value.Ⅰ.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(artiPolishingResultInfo.value.Ⅰ, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "correctTitle2",
                          style: {"text-align":"center"},
                          key: 'PⅠ'+index
                        }, [
                          _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_44)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (artiPolishingResultInfo.value.Ⅱ && artiPolishingResultInfo.value.Ⅱ.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(artiPolishingResultInfo.value.Ⅱ, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "correctTitle5",
                          key: 'PⅡ'+index
                        }, [
                          _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_45)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (artiPolishingResultInfo.value.Ⅲ && artiPolishingResultInfo.value.Ⅲ.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "correctTitle" }, " 修改思路和方法 ", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(artiPolishingResultInfo.value.Ⅲ, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            style: {"text-indent":"unset"},
                            class: "correctTitle5",
                            key: 'PⅢ'+index
                          }, [
                            _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_46)
                          ]))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("div", {
                    innerHTML: artiPolishingInfo.value.artiPulishingResult
                  }, null, 8, _hoisted_48)
                ]))
          ], 64))
        : _createCommentVNode("", true),
      (!Object.keys(artiCorrectingResultInfo.value).length && !Object.keys(artiRewriteResultInfo.value).length && !Object.keys(artiPolishingResultInfo.value).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_49, _cache[23] || (_cache[23] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1),
            _createElementVNode("div", null, "结果将在此处展示！", -1)
          ])))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})